const columns = [
    {
        name: "name",
        label: "",
        field: "name",
        sortable: true,
        align: "left"
    },
    {
        name: "total_users",
        label: "",
        field: "",
        sortable: false,
        align: "left"
    },
    {
        name: "access",
        label: "",
        sortable: false,
        align: "left"
    },
    {
        name: "icons",
        label: "",
        field: "",
        sortable: false,
        align: "right"
    }
];

export default columns;
